import { HttpContext, HttpContextToken } from '@angular/common/http';

/**
 * Set on a request to opt it out of ErrorInterceptor's generic toast when a
 * failure is an expected, already-handled business case (e.g. "no schema
 * configured yet for this enclave", "dataset not created yet") rather than a
 * real error. Logging via LoggingService still always happens — only the
 * user-facing toast is skipped, matching the component's own silent
 * `error: () => {...}` handling of these calls.
 */
export const SKIP_ERROR_TOAST = new HttpContextToken<boolean>(() => false);

export function skipErrorToastContext(): { context: HttpContext } {
  return { context: new HttpContext().set(SKIP_ERROR_TOAST, true) };
}
